var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 2.98804H9.33332C5.65142 2.98804 2.66666 5.97281 2.66666 9.6547V22.988C2.66666 26.6699 5.65142 29.6547 9.33332 29.6547H22.6667C26.3486 29.6547 29.3333 26.6699 29.3333 22.988V9.6547C29.3333 5.97281 26.3486 2.98804 22.6667 2.98804Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 15.4814C21.4979 16.5911 21.3083 17.7244 20.7917 18.7201C20.275 19.7159 19.4575 20.5233 18.4555 21.0277C17.4535 21.532 16.3179 21.7076 15.2104 21.5294C14.1028 21.3511 13.0797 20.8282 12.2864 20.035C11.4932 19.2418 10.9703 18.2186 10.7921 17.1111C10.6139 16.0035 10.7894 14.868 11.2938 13.8659C11.7981 12.8639 12.6056 12.0464 13.6013 11.5298C14.597 11.0131 15.7303 10.8236 16.84 10.9881C17.9719 11.156 19.0198 11.6834 19.8289 12.4925C20.638 13.3016 21.1655 14.3495 21.3333 15.4814Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 8.98804H23.3467",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.656844ffdcf3333f1293dcc802f2c4e5.svg";
export { ForwardRef as ReactComponent };